var initializeBlockGallery = function(block){
    
    jQuery('.gallery-slick:not(.slick-initialized)').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        slidesPerRow: 1,
        dots: false,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        fade: false,
        easing: "linear",
        pauseOnHover: false,
        infinite: true,
        draggable: false,
        swipe: true,
        adaptiveHeight: true,
    });
    
    jQuery(document).on('opening', '.remodal', function(){
        setTimeout(function(){
            jQuery('.remodal .gallery-slick').slick("refresh");
        }, 50);
    });
    
    jQuery("li", block).on('click', function(){
        
        var current = jQuery(this);
        var index = current.index();
        var remodalID = current.attr("data-remodal-target");
        
        jQuery('.remodal[data-remodal-id="' + remodalID + '"] .gallery-slick').slick("slickGoTo", index);
        
    });
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-gallery').each(function(){
        initializeBlockGallery(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=gallery', initializeBlockGallery);
